import { createAction } from 'typesafe-actions'

export const setStatusModalVisible = createAction('status->SET')<boolean>()
